module.exports = "function renderList (listProps) {\n  return (\n    <CellMeasurer {...listProps}>\n      {({ getRowHeight }) => (\n        <List\n          rowHeight={getRowHeight}\n          {...listProps}\n        />\n      )}\n    </CellMeasurer>\n  );\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./examples/dynamic-cell-measurer.js
 ** module id = 366
 ** module chunks = 0
 **/